import React from 'react';
import { Preloader } from '@cian/preloader-component';
import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';
import { Card } from '../Card';

import * as styles from './styles.css';
import { IPageState } from '../../types/page';
import { TUser } from '../../api';

interface IResultsMobile {
  results: IResultsState;
  user: TUser;
  page: IPageState;
  removeFavorite(entityId: number): void;
}

export const ResultsMobile: React.FC<IResultsMobile> = ({ results, page, user, removeFavorite }) => {
  const { status, favoriteEntities, total } = results;

  const handleRemove = (id: number) => {
    removeFavorite(id);
  };

  return (
    <div className={styles['container']}>
      {favoriteEntities.map(favoriteEntity => (
        <Card
          key={'item-' + favoriteEntity.entityId}
          total={total}
          favoriteEntity={favoriteEntity}
          page={page}
          user={user}
          removeFavorite={() => handleRemove(favoriteEntity.entityId)}
        />
      ))}
      {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
        <div key="preloader" className={styles['preloader']}>
          <Preloader size={64} />
        </div>
      )}
    </div>
  );
};
